var _path, _circle, _circle2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 8.9462C17.097 4.59207 9.2332 -1.5037 0.999947 8.9462C3.77075 13.3003 12.8748 18.842 19.9998 8.9462Z",
    stroke: "#2E7161"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.35412,
    cy: 4.35412,
    r: 3.85412,
    transform: "matrix(-1 0 0 1 14.8621 4.59229)",
    stroke: "#2E7161"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.54125,
    cy: 1.54125,
    r: 1.54125,
    transform: "matrix(-1 0 0 1 12.2367 7.28638)",
    fill: "#2E7161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5383 2.88527C17.6991 2.66075 18.0114 2.60906 18.2359 2.76982C18.4605 2.93058 18.5122 3.24291 18.3514 3.46744L17.5383 2.88527ZM16.2008 4.75335L17.5383 2.88527L18.3514 3.46744L17.0138 5.33552L16.2008 4.75335Z",
    fill: "#2E7161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2522 1.00004C10.2522 0.723899 10.4761 0.500041 10.7522 0.500041C11.0283 0.500041 11.2522 0.723899 11.2522 1.00004L10.2522 1.00004ZM10.2522 3.29761L10.2522 1.00004L11.2522 1.00004L11.2522 3.29761L10.2522 3.29761Z",
    fill: "#2E7161"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42847 3.78627C2.24729 3.57787 2.26936 3.26206 2.47776 3.08088C2.68616 2.8997 3.00197 2.92177 3.18315 3.13017L2.42847 3.78627ZM3.93589 5.52019L2.42847 3.78627L3.18315 3.13017L4.69057 4.86409L3.93589 5.52019Z",
    fill: "#2E7161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.f2eb1ed18982a1f428f36405d402899d.svg";
export { ForwardRef as ReactComponent };